import { SaveOutlined } from '@ant-design/icons';
import { ContentHeader } from '@components';
import { Button, Col, DatePicker, Form, Input, Row } from 'antd';
import TextArea from 'antd/es/input/TextArea';
import {
    ArcElement,
    BarElement,
    CategoryScale,
    Chart as ChartJS,
    Legend,
    LinearScale,
    Title,
    Tooltip,
} from 'chart.js';
import dayjs from 'dayjs';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import ModalTextForm from '../components/modal/ModalTextForm';
import { defaultAvatarImg } from '../constants';
import { Links } from '../helpers/Links';
import { menuHelper } from '../helpers/account';
import { dateCommon, roundToTwo, validateMessages } from '../helpers/common';
import { CongViec } from '../models/congviec/CongViec';
import { ThongKeTrangChuResponse } from '../models/danhmuc/DanhMuc';
import { ChiTietHopDongResponse } from '../models/hopdong/HopDong';
import { NguoiDungResponse } from '../models/nguoidung/NguoiDung';
import LoadingDashboardPage from '../modules/loading/LoadingDashboardPage';
import TimeKeeping from '../modules/time-keeping/TimeKeeping';
import { layDsCongViecTheoNvKhoiTao, luuCongViec } from '../services/congviec';
import { thongKeChungTrangChu } from '../services/danhmuc';
import { layCTHopDong, layDsHopDongTheoIdNhanVien } from '../services/hopdong';
import { layThongTinCaNhan } from '../services/nguoidung';
import { hideLoadingScreen, showLoadingScreen } from '../store/reducers/loading';
import KPITrangChu from './kpi/KPITrangChu';
import PheDuyetPhepTrangChu from './phep/PheDuyetPhepTrangChu';
import TatCaNhanVienSelectBox from './utils/TatCaNhanVienSelectBox';
import PheDuyetThemGioTrangChu from './ngoaigio/PheDuyetThemGioTrangChu';
import ThongBaoChungTable from './utils/ThongBaoChungTable';
import GiaoViecKPI from './kpi/GiaoViecKPI';

ChartJS.register(
    ArcElement,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend
);

const Dashboard2 = () => {
    const navigate = useNavigate();
    const [t] = useTranslation();
    const user = useSelector((state: any) => state.auth.currentUser);
    const menu: any = menuHelper.checkMultiPermission([
        Links.CongViec.Them,
        Links.CongViec.GiaoViec,
        Links.CongViec.Xem,
        Links.KPI.ThemKPI,
        Links.KPI.DuyetKPI,
        Links.KPI.VanPhongGiaoViec,
        Links.ChamCong.ThemChamCong,
        Links.ChamCong.QuanTriChamCongThang,
        Links.ChamCong.QuanTriChamNgoaiGio,
        Links.ChamCong.DuyetNgoaiGio,
        Links.ChamCong.DuyetChamCong,
        Links.Phep.ChiTiet,
        Links.Phep.Xem,
        Links.Phep.DanhSachPheDuyet,
        Links.NgoaiGio.DangKy,
        Links.NgoaiGio.Xem,
        Links.NgoaiGio.PheDuyet,
        Links.KPI.KPICaNhan,
        Links.ThuNhapCaNhan.XemThuNhap,
    ]);
    const [showModalCongViec, setShowModalCongViec] = useState<boolean>(false);
    const [modalCongViecTitle, setModalCongViecTitle] = useState<string>("");
    const [form] = Form.useForm();
    const dispatch = useDispatch();
    const [loading, setLoading] = useState<boolean>(false);
    const [userInfo, setUserInfo] = useState<NguoiDungResponse>(new NguoiDungResponse)
    const [thongKeChung, setThongKeChung] = useState<ThongKeTrangChuResponse>(new ThongKeTrangChuResponse);
    const [sLNvTrinhDo, setSLNvTrinhDo] = useState(0);
    const [reloadPage, setReloadPage] = useState<boolean>(true);
    const [confirmModal, setConfirmModal] = useState<any>({});
    const [isGiaoViec, setIsGiaoViec] = useState<boolean>(false);
    const [dsCongViec, setDsCongViec] = useState<Array<CongViec>>([]);
    const [dsGiaoViec, setDsGiaoViec] = useState<Array<any>>([]);
    const now = dayjs();
    const [hopDongInfo, setHopDongInfo] = useState<ChiTietHopDongResponse>(new ChiTietHopDongResponse);

    const setFormModalCongViec = (value: any | null, isGiaoViec: boolean) => {
        setIsGiaoViec(isGiaoViec);
        setModalCongViecTitle(isGiaoViec ? "Giao việc" : "Thêm mới công việc");
        var today = new Date();
        form.setFieldsValue({
            "id": value?.id || 0,
            "idNhanViens": isGiaoViec ? value?.idNhanViens || [] : [user.idNhanVien],
            "tuNgay": dayjs(dateCommon.formatDate(value?.tuNgay || today), "DD/MM/YYYY"),
            "denNgay": dayjs(dateCommon.formatDate(value?.denNgay || new Date(today.getFullYear(), today.getMonth() + 1, 0)), "DD/MM/YYYY"),
            "noiDung": value?.noiDung || "",
        });
        setShowModalCongViec(true);
    }

    const options = {
        responsive: true,
        plugins: {
            legend: {
                position: 'bottom' as const,
            },
        },
    };
    const optionsDougnNut = {
        responsive: true,
        plugins: {
            legend: {
                position: 'bottom' as const,
            },
            tooltip: {
                callbacks: {
                    afterLabel: function (context: any) {
                        return "(" + roundToTwo(context.formattedValue * 100 / sLNvTrinhDo) + "%)";
                    },
                }
            }
        },
    };
    const [dataTuoiTac, setDataTuoiTac] = useState({
        labels: ['Dưới 30 tuổi', '30 - 40 tuổi', '40 - 50 tuổi', 'Trên 50 tuổi'],
        datasets: [
            {
                label: 'Nam',
                data: [0, 0, 0, 0],
                backgroundColor: 'rgb(53, 162, 235)',
                stack: 'Stack 0',
                categoryPercentage: 0.3
            },
            {
                label: 'Nữ',
                data: [0, 0, 0, 0],
                backgroundColor: 'rgb(255, 206, 86)',
                stack: 'Stack 1',
                categoryPercentage: 0.3
            },
        ],
    });
    const [dataTrinhDo, setDataTrinhDo] = useState({
        labels: ['Đại học', 'Thạc sĩ', 'Tiến sĩ', 'Khác'],
        datasets: [
            {
                label: '# of Votes',
                data: [12, 19, 3, 5],
                backgroundColor: [
                    'rgb(255, 99, 132)',
                    'rgb(54, 162, 235)',
                    'rgb(255, 206, 86)',
                    'rgb(75, 192, 192)',
                ],
                borderWidth: 0
            },
        ],
    });

    const disableTuNgay = (current: any) => {
        const denNgay = form.getFieldValue('denNgay');
        return current && current > denNgay;
    }

    const disableDenNgay = (current: any) => {
        const tuNgay = form.getFieldValue('tuNgay');
        return current && current < tuNgay;
    }

    const onFinish = async (values: any) => {
        setConfirmModal({
            isShowModal: true,
            title: isGiaoViec ? "Lưu giao việc" : "Lưu công việc",
            content: isGiaoViec ? <>Bạn có muốn <label>Lưu</label> giao việc này không?</> :
                <>Bạn có muốn <label>Lưu</label> công việc này không?</>,
            onSubmit: () => { eventSaveCongViec() }
        });
    };

    const eventSaveCongViec = async () => {
        form.validateFields().then(async (values) => {
            dispatch(showLoadingScreen())
            try {
                if (!isGiaoViec) {
                    values.idNhanViens = [user.idNhanVien];
                }
                values.isGiaoViec = isGiaoViec;
                var request = { ...values };
                await luuCongViec(request);
                toast.success(isGiaoViec ? "Lưu giao việc thành công" : "Lưu công việc thành công");
            } catch (error: any) {
                toast.error(error);
            }
            dispatch(hideLoadingScreen());
            setReloadPage(true);
        }).catch((e: any) => {
            toast.error(e);
            dispatch(hideLoadingScreen());
        });
        setShowModalCongViec(false);
    }

    const layThongTinNguoiDung = async () => {
        try {
            setLoading(true);
            var rs = await layThongTinCaNhan();
            setUserInfo(rs);
            setLoading(false);
        }
        catch (err: any) {
            setLoading(false);
        }
    }

    const layChiTietHopDong = async () => {
        try {
            setLoading(true);
            var rs = await layDsHopDongTheoIdNhanVien(user.idNhanVien);
            if (rs.dsHopDong.length > 0) {
                var selectDefault = rs.dsHopDong.find(x => x.trangThai === 1) || rs.dsHopDong[0];
                var temp = await layCTHopDong(selectDefault.id)
                setHopDongInfo(temp);
            }
            setLoading(false);
        }
        catch (error: any) {
            setLoading(false);
        }
    }

    const layThongKeTrangChu = async () => {
        try {
            setLoading(true);
            var rs = await thongKeChungTrangChu();
            setThongKeChung(rs);
            setDataTuoiTac({
                labels: ['Dưới 30 tuổi', '30 - 40 tuổi', '40 - 50 tuổi', 'Trên 50 tuổi'],
                datasets: [
                    {
                        label: 'Nam',
                        data: [rs?.tuoiTacGioiTinhResponse?.duoiBaMuoiNam, rs?.tuoiTacGioiTinhResponse?.baMuoiBonMuoiNam, rs?.tuoiTacGioiTinhResponse?.bonMuoiNamMuoiNam, rs?.tuoiTacGioiTinhResponse?.trenNamMuoiNam],
                        backgroundColor: 'rgb(53, 162, 235)',
                        stack: 'Stack 0',
                        categoryPercentage: 0.3
                    },
                    {
                        label: 'Nữ',
                        data: [rs?.tuoiTacGioiTinhResponse?.duoiBaMuoiNu, rs?.tuoiTacGioiTinhResponse?.baMuoiBonMuoiNu, rs?.tuoiTacGioiTinhResponse?.bonMuoiNamMuoiNu, rs?.tuoiTacGioiTinhResponse?.trenNamMuoiNu],
                        backgroundColor: 'rgb(255, 206, 86)',
                        stack: 'Stack 1',
                        categoryPercentage: 0.3
                    },
                ],
            });
            setDataTrinhDo({
                labels: rs.thongKeTrinhDoResponse.map((item) => item?.ten),
                datasets: [
                    {
                        label: 'Số lượng',
                        data: rs.thongKeTrinhDoResponse.map((item) => item.soLuongNhanVien),
                        backgroundColor: [
                            'rgb(255, 99, 132)',
                            'rgb(54, 162, 235)',
                            'rgb(255, 206, 86)',
                            'rgb(75, 192, 192)',
                        ],
                        borderWidth: 0
                    },
                ],
            })
            setSLNvTrinhDo(rs.tongSoNhanVienTrinhDo);
            setLoading(false);
        }
        catch (err: any) {
            setLoading(false);
        }
    }

    const layDsCongViec = async () => {
        var data = await layDsCongViecTheoNvKhoiTao();
        var dataCongViec = data.filter((item: CongViec) => item.isGiaoViec === 0)
        while (dataCongViec.length < 5) {
            dataCongViec.push(new CongViec());
        }
        setDsCongViec(dataCongViec.map((item: any, index: any) => {
            return { ...item, key: index }
        }));
        var dataGiaoViec = data.filter((item: CongViec) => item.isGiaoViec === 1)
        var giaoViecs: Array<any> = []
        dataGiaoViec.map((item: CongViec) =>
            item.nhanViens.map((_item: any) => {
                giaoViecs.push({ ..._item, noiDung: item.noiDung, hanCuoi: item.thoiGianYeuCauHoanThanh, idCongViec: item.id })
            })
        )
        while (giaoViecs.length < 5) {
            giaoViecs.push(new CongViec());
        }
        setDsGiaoViec(giaoViecs.map((item: any, index: any) => {
            return { ...item, key: index }
        }));
    }

    useEffect(() => {
        if (reloadPage) {
            layThongTinNguoiDung();
            layThongKeTrangChu();
            layChiTietHopDong();
            setReloadPage(false);
        }
    }, [reloadPage]);

    if (loading) {
        return (
            <LoadingDashboardPage />
        );
    }
    return (
        <div>
            <ContentHeader title={t<string>('menusidebar.label.dashboard')} />
            <section>
                {
                    showModalCongViec &&
                    <ModalTextForm
                        title={modalCongViecTitle}
                        hideFooter
                        show={showModalCongViec}
                        handleClose={() => setShowModalCongViec(false)}
                    >
                        <Form
                            layout="vertical"
                            validateMessages={validateMessages}
                            form={form}
                            onFinish={onFinish}
                        >
                            <Form.Item
                                hidden
                                name="id"
                            >
                                <Input />
                            </Form.Item>
                            <Row gutter={16}>
                                <Col span={24}>
                                    {
                                        isGiaoViec
                                            ? <Form.Item
                                                label="Nhân viên"
                                                name="idNhanViens"
                                                rules={[{ required: true }]}
                                            >
                                                <TatCaNhanVienSelectBox multiple onChange={(e: any) => {
                                                    form.setFieldValue('idNhanViens', e.target.value);
                                                }} />
                                            </Form.Item>
                                            : <Form.Item
                                                label="Nhân viên"
                                            >
                                                {user.hoTen}
                                            </Form.Item>
                                    }
                                </Col>
                            </Row>
                            <Row gutter={16}>
                                <Col span={12}>
                                    <Form.Item
                                        label="Thời gian giao"
                                        name="tuNgay"
                                        rules={[{ required: true }]}
                                    >
                                            <DatePicker changeOnBlur={true} disabledDate={disableTuNgay} style={{ width: "100%" }} placeholder="Từ ngày" format={["DD/MM/YYYY", "DDMMYYYY"]} />
                                    </Form.Item>
                                </Col>
                                <Col span={12}>
                                    <Form.Item
                                        label="Thời gian yêu cầu hoàn thành"
                                        name="denNgay"
                                        rules={[{ required: true }]}
                                    >
                                            <DatePicker changeOnBlur={true} disabledDate={disableDenNgay} style={{ width: "100%" }} placeholder="Đến ngày" format={["DD/MM/YYYY", "DDMMYYYY"]} />
                                    </Form.Item>
                                </Col>
                            </Row>
                            <Row gutter={16}>
                                <Col span={24}>
                                    <Form.Item
                                        label="Nội dung"
                                        name="noiDung"
                                        rules={[
                                            {
                                                required: true
                                            }
                                        ]}
                                    >
                                        <TextArea rows={3} />
                                    </Form.Item>
                                </Col>
                            </Row>
                            <Form.Item>
                                <Button
                                    type="primary"
                                    className="float-right"
                                    htmlType="submit"
                                    icon={<SaveOutlined rev="" />}
                                >
                                    Lưu
                                </Button>
                            </Form.Item>
                        </Form>
                    </ModalTextForm>
                }
                <Row className="form-group" gutter={16}>
                    <Col xs={0} sm={24} xl={12} style={{ color: "#071C50" }}>
                        <Row style={{ marginBottom: "10px" }}>
                            <Col span="24">
                                <Row><b style={{ fontSize: "20px", color: "#071C50" }}>Thông tin cá nhân</b></Row>
                            </Col>
                        </Row>
                        <div className="card" style={{ height: "234px", overflowX: "auto" }}>
                            <Row align="middle">
                                <Col span="7">
                                    <Row justify="center" className="mt-4">
                                        <Col span="24">
                                            <div className="text-center">
                                                <img className="profile-user-img img-fluid img-circle" style={{ width: "140px", height: "140px" }}
                                                    /*src={(userInfo?.avatar == null || userInfo?.avatar == "") ? defaultAvatarImg : userInfo?.avatar.replace("View\\public", "").replace(/\\/g, "/")}*/
                                                    src={(userInfo?.avatar == null || userInfo?.avatar == "") ? defaultAvatarImg : userInfo?.avatar.replace(/\\/g, "/")}
                                                    alt="User profile picture"
                                                />
                                            </div>
                                        </Col>
                                    </Row>
                                </Col>
                                <Col span="17" className="mt-4">
                                    <div>
                                        <Link className="text-lg" to={Links.NhanVien.HoSoCaNhan} style={{ fontWeight: "bold" }}>
                                            {user.isAdmin ? "Quản trị hệ thống" : userInfo?.hoTen?.toUpperCase()}
                                        </Link>
                                    </div>
                                    <Row className="mb-1">
                                        <Col span="2" className="mt-2">
                                            <i className="fa fa-briefcase text-lg" />
                                        </Col>
                                        <Col span="13">
                                            <div>Phòng ban</div>
                                            <label>{user.isAdmin ? "Quỹ Đầu tư phát triển TPĐN": userInfo?.tenDonVi}</label>
                                        </Col>
                                        <Col span="2" className="mt-2">
                                            <i className="fa fa-id-card text-lg" />
                                        </Col>
                                        <Col span="7">
                                            <div>Chức vụ</div>
                                            <label>{user.isAdmin ? "Quản trị viên" : userInfo?.tenChucVu}</label>
                                        </Col>
                                    </Row>
                                    <Row className="mb-1">
                                        <Col span="2" className="mt-2">
                                            <i className="fa fa-envelope text-lg" />
                                        </Col>
                                        <Col span="13">
                                            <div>Email</div>
                                            <label>{user.isAdmin ? "ddif@danang.gov.vn" : userInfo?.email}</label>
                                        </Col>
                                        <Col span="2" className="mt-2">
                                            <i className="fa fa-phone text-lg" />
                                        </Col>
                                        <Col span="7">
                                            <div>Điện thoại</div>
                                            <label>{user.isAdmin ? "02363888769" : userInfo?.dienThoai}</label>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col span="2" className="mt-2">
                                            <i className="fa fa-file text-lg" />
                                        </Col>
                                        <Col span="22">
                                            <div>Loại hơp đồng</div>
                                            <Link to={Links.HopDong.CaNhan} style={{ fontWeight: "bold" }}>
                                                {hopDongInfo?.loaiHopDong}
                                            </Link>
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                        </div>
                    </Col>
                    <Col xs={24} xl={12}>
                        <ThongBaoChungTable />
                    </Col>
                    {
                        menu[Links.KPI.ThemKPI] && !user.isQuanLy &&
                        <KPITrangChu />
                    }
                    {
                        (menu[Links.KPI.DuyetKPI] || menu[Links.KPI.VanPhongGiaoViec]) &&
                        <GiaoViecKPI />
                    }
                    {
                        menu[Links.Phep.DanhSachPheDuyet] &&
                        <PheDuyetPhepTrangChu />
                    }
                    {
                        menu[Links.NgoaiGio.PheDuyet] &&
                        <PheDuyetThemGioTrangChu  />
                    }
                    {/*<Col xs={24} xl={12}>*/}
                    {/*    <Row style={{ marginBottom: "10px" }}>*/}
                    {/*        <Col span="20">*/}
                    {/*            <Row><b style={{ fontSize: "20px", color: "#071C50" }}>Công việc</b></Row>*/}
                    {/*        </Col>*/}
                    {/*        <Col span="4">*/}
                    {/*            <Space className='float-right'>*/}
                    {/*                {*/}
                    {/*                    menu[Links.CongViec.Them] &&*/}
                    {/*                    <Button*/}
                    {/*                        className="hrm-btn hrm-btn-warning float-right"*/}
                    {/*                        onClick={() => {*/}
                    {/*                            setFormModalCongViec(null, false);*/}
                    {/*                        }}*/}
                    {/*                        icon={<PlusOutlined rev="" />}*/}
                    {/*                    >*/}
                    {/*                        Thêm công việc*/}
                    {/*                    </Button>*/}
                    {/*                }*/}
                    {/*            </Space>*/}
                    {/*        </Col>*/}
                    {/*    </Row>*/}
                    {/*    <Row>*/}
                    {/*        <div className="card" style={{ width: "100%" }}>*/}
                    {/*            <Table*/}
                    {/*                scroll={{ y: 200, x: "max-content" }}*/}
                    {/*                pagination={false}*/}
                    {/*                size="small"*/}
                    {/*                loading={isLoadingTable}*/}
                    {/*                locale={{ emptyText: "Không có dữ liệu" }}*/}
                    {/*                dataSource={dsCongViec}*/}
                    {/*            >*/}
                    {/*                <Column*/}
                    {/*                    align="center"*/}
                    {/*                    title="STT"*/}
                    {/*                    key="STT"*/}
                    {/*                    width="7%"*/}
                    {/*                    render={(value, record: any, index) => (*/}
                    {/*                        value.noiDung != null ? <>{index + 1}</> : <div style={{ height: "22px" }}></div>*/}
                    {/*                    )}*/}
                    {/*                />*/}
                    {/*                <Column*/}
                    {/*                    title="Nội dung"*/}
                    {/*                    key="noiDung"*/}
                    {/*                    render={(value, record: any, index) => {*/}
                    {/*                        return record.noiDung == undefined ? index == 0 &&*/}
                    {/*                        <div className="text-center" style={{ paddingLeft: "200px" }}>Không có dữ liệu</div> :*/}
                    {/*                        <Link*/}
                    {/*                            style={{ fontWeight: "bold" }}*/}
                    {/*                            to={Links.CongViec.Xem + "?id=" + record?.id}*/}
                    {/*                        >*/}
                    {/*                            {record.noiDung}*/}
                    {/*                        </Link>;*/}
                    {/*                    }}*/}
                    {/*                />*/}
                    {/*                <Column*/}
                    {/*                    align="center"*/}
                    {/*                    title="Hạn cuối"*/}
                    {/*                    width="15%"*/}
                    {/*                    key="thoiGianYeuCauHoanThanh"*/}
                    {/*                    render={(value, record: any, index) => {*/}
                    {/*                        return dateCommon.formatDate(record.thoiGianYeuCauHoanThanh);*/}
                    {/*                    }}*/}
                    {/*                />*/}
                    {/*                <Column*/}
                    {/*                    align="center"*/}
                    {/*                    title="Trạng thái"*/}
                    {/*                    key="trangThai"*/}
                    {/*                    width="15%"*/}
                    {/*                    render={(value, record: any, index) => {*/}
                    {/*                        var tag = (<Tag color="default"></Tag>);*/}
                    {/*                        switch (record.trangThai) {*/}
                    {/*                            case trangThaiCongViec.khoiTao:*/}
                    {/*                                if (dayjs(record.thoiGianYeuCauHoanThanh) >= now) {*/}
                    {/*                                    tag = (<Tag color="processing">Khởi tạo</Tag>);*/}
                    {/*                                } else tag = (<Tag color="error">Hết hạn</Tag>);*/}
                    {/*                                break;*/}
                    {/*                            case trangThaiCongViec.dangThucHien:*/}
                    {/*                                if (dayjs(record.thoiGianYeuCauHoanThanh) >= now) {*/}
                    {/*                                    tag = (<Tag color="warning">Đang thực hiện</Tag>);*/}
                    {/*                                } else tag = (<Tag color="error">Hết hạn</Tag>);*/}
                    {/*                                break;*/}
                    {/*                            case trangThaiCongViec.daHoanThanh:*/}
                    {/*                                if (dayjs(record.thoiGianYeuCauHoanThanh) >= dayjs(record.ngayHoanThanh)) {*/}
                    {/*                                    tag = (<Tag color="success">Đã hành thành</Tag>);*/}
                    {/*                                } else tag = (<Tag color="orange">Trễ hạn</Tag>);*/}
                    {/*                                break;*/}
                    {/*                            case undefined: tag = (<></>);*/}
                    {/*                        }*/}
                    {/*                        return tag;*/}
                    {/*                    }}*/}
                    {/*                />*/}
                    {/*            </Table>*/}
                    {/*        </div>*/}
                    {/*    </Row>*/}
                    {/*</Col>*/}
                    {/*{*/}
                    {/*    menu[Links.CongViec.GiaoViec] &&*/}
                    {/*    <Col xs={24} xl={12}>*/}
                    {/*        <Row style={{ marginBottom: "10px" }}>*/}
                    {/*            <Col span="20">*/}
                    {/*                <Row><b style={{ fontSize: "20px", color: "#071C50" }}>Giao việc</b></Row>*/}
                    {/*            </Col>*/}
                    {/*            <Col span="4">*/}
                    {/*                <Space className='float-right'>*/}
                    {/*                    <Button*/}
                    {/*                        className="hrm-btn hrm-btn-warning float-right"*/}
                    {/*                        onClick={() => {*/}
                    {/*                            setFormModalCongViec(null, true);*/}
                    {/*                        }}*/}
                    {/*                        icon={<PlusOutlined rev="" />}*/}
                    {/*                    >*/}
                    {/*                        Giao việc*/}
                    {/*                    </Button>*/}
                    {/*                </Space>*/}
                    {/*            </Col>*/}
                    {/*        </Row>*/}
                    {/*        <Row>*/}
                    {/*            <div className="card" style={{ width: "100%" }}>*/}
                    {/*                <Table*/}
                    {/*                    scroll={{ y: 200, x: "max-content" }}*/}
                    {/*                    pagination={false}*/}
                    {/*                    size="small"*/}
                    {/*                    loading={isLoadingTable}*/}
                    {/*                    locale={{ emptyText: "Không có dữ liệu" }}*/}
                    {/*                    dataSource={dsGiaoViec}*/}
                    {/*                >*/}
                    {/*                    <Column*/}
                    {/*                        align="center"*/}
                    {/*                        title="STT"*/}
                    {/*                        key="STT"*/}
                    {/*                        width="7%"*/}
                    {/*                        render={(value, record: any, index) => (*/}
                    {/*                            value.tenNhanVien != null ? <>{index + 1}</> : <div style={{ height: "22px" }}></div>*/}
                    {/*                        )}*/}
                    {/*                    />*/}
                    {/*                    <Column title=" Người thực hiện" width="25%" dataIndex="tenNhanVien" key="tenNhanVien" />*/}
                    {/*                    <Column*/}
                    {/*                        title="Nội dung"*/}
                    {/*                        key="noiDung"*/}
                    {/*                        render={(value, record: any, index) => {*/}
                    {/*                            return record.noiDung == undefined ? index == 0 &&*/}
                    {/*                            <div className="text-center">Không có dữ liệu</div> :*/}
                    {/*                            <Link*/}
                    {/*                                style={{ fontWeight: "bold" }}*/}
                    {/*                                to={Links.CongViec.Xem + "?id=" + record?.idCongViec}*/}
                    {/*                            >*/}
                    {/*                                {record.noiDung}*/}
                    {/*                            </Link>;*/}
                    {/*                        }}*/}
                    {/*                    />*/}
                    {/*                    <Column*/}
                    {/*                        width="15%"*/}
                    {/*                        align="center"*/}
                    {/*                        title="Hạn cuối"*/}
                    {/*                        key="hanCuoi"*/}
                    {/*                        render={(value, record: any, index) => {*/}
                    {/*                            return dateCommon.formatDate(record.hanCuoi);*/}
                    {/*                        }}*/}
                    {/*                    />*/}
                    {/*                    <Column*/}
                    {/*                        align="center"*/}
                    {/*                        title="Trạng thái"*/}
                    {/*                        key="trangThai"*/}
                    {/*                        width="15%"*/}
                    {/*                        render={(value, record: any, index) => {*/}
                    {/*                            var tag = (<Tag color="default"></Tag>);*/}
                    {/*                            switch (record.trangThai) {*/}
                    {/*                                case trangThaiCongViec.khoiTao:*/}
                    {/*                                    if (dayjs(record.thoiGianYeuCauHoanThanh) >= now) {*/}
                    {/*                                        tag = (<Tag color="processing">Khởi tạo</Tag>);*/}
                    {/*                                    } else tag = (<Tag color="error">Hết hạn</Tag>);*/}
                    {/*                                    break;*/}
                    {/*                                case trangThaiCongViec.dangThucHien:*/}
                    {/*                                    if (dayjs(record.thoiGianYeuCauHoanThanh) >= now) {*/}
                    {/*                                        tag = (<Tag color="warning">Đang thực hiện</Tag>);*/}
                    {/*                                    } else tag = (<Tag color="error">Hết hạn</Tag>);*/}
                    {/*                                    break;*/}
                    {/*                                case trangThaiCongViec.daHoanThanh:*/}
                    {/*                                    if (dayjs(record.thoiGianYeuCauHoanThanh) >= dayjs(record.ngayHoanThanh)) {*/}
                    {/*                                        tag = (<Tag color="success">Đã hành thành</Tag>);*/}
                    {/*                                    } else tag = (<Tag color="orange">Trễ hạn</Tag>);*/}
                    {/*                                    break;*/}
                    {/*                                case undefined: tag = (<></>);*/}
                    {/*                            }*/}
                    {/*                            return tag;*/}
                    {/*                        }}*/}
                    {/*                    />*/}
                    {/*                </Table>*/}
                    {/*            </div>*/}
                    {/*        </Row>*/}
                    {/*</Col>*/}
                    {/*}*/}
                    <Col xs={24} xl={24}>
                        {
                            menu[Links.ChamCong.QuanTriChamCongThang] &&
                            <TimeKeeping />
                        }
                    </Col>
                </Row>
                <Row className="form-group" gutter={16}>
                    <Col span={24} style={{ color: "#071C50" }}>
                        <div className="card">
                            <Row align="middle">
                                {
                                    menu[Links.Phep.ChiTiet] &&
                                    <Col span="6">
                                        <div style={{ textAlign: "center", margin: "10px", minWidth: "80px" }} >
                                            <div className="icon-chucnang">
                                                <Link to={Links.Phep.ChiTiet}>
                                                    <i className="icon-chucnang fas fa-calendar-check nav-icon"></i>
                                                </Link>
                                            </div>
                                            <p className="text-chucnang">
                                                <Link to={Links.Phep.ChiTiet}>
                                                    <b className="text-chucnang">Đăng ký nghỉ phép</b>
                                                </Link>
                                            </p>
                                        </div>
                                    </Col>
                                }
                                {menu[Links.NgoaiGio.DangKy] &&
                                    <Col span="6">
                                        <div style={{ textAlign: "center", margin: "10px", minWidth: "80px" }}>
                                            <div className="icon-chucnang">
                                                <Link to={Links.NgoaiGio.DangKy}>
                                                    <i className="icon-chucnang fas fa-calendar-plus nav-icon"></i>
                                                </Link>
                                            </div>
                                            <p className="text-chucnang">
                                                <Link to={Links.NgoaiGio.DangKy}>
                                                    <b className="text-chucnang">Đăng ký thêm giờ</b>
                                                </Link>
                                            </p>
                                        </div>
                                    </Col>
                                }
                                {menu[Links.KPI.KPICaNhan] &&
                                    <Col span="6">
                                        <div style={{ textAlign: "center", margin: "10px", minWidth: "80px" }}>
                                            <div className="icon-chucnang">
                                                <Link to={Links.KPI.KPICaNhan}>
                                                    <i className="icon-chucnang fas fa-tachometer-alt nav-icon"></i>
                                                </Link>
                                            </div>
                                            <p className="text-chucnang">
                                                <Link to={Links.KPI.KPICaNhan}>
                                                    <b className="text-chucnang">KPI cá nhân</b>
                                                </Link>
                                            </p>
                                        </div>
                                    </Col>
                                }
                                {menu[Links.ThuNhapCaNhan.XemThuNhap] &&
                                    <Col span="6">
                                        <div style={{ textAlign: "center", margin: "10px", minWidth: "80px" }}>
                                            <div className="icon-chucnang">
                                                <Link to={Links.ThuNhapCaNhan.XemThuNhap}>
                                                    <i className="icon-chucnang fas fa-hand-holding-usd nav-icon"></i>
                                                </Link>
                                            </div>
                                            <p className="text-chucnang">
                                                <Link to={Links.ThuNhapCaNhan.XemThuNhap}>
                                                    <b className="text-chucnang">Thu nhập cá nhân</b>
                                                </Link>
                                            </p>
                                        </div>
                                    </Col>
                                }
                                {menu[Links.ChamCong.QuanTriChamCongThang] &&
                                    <Col span="6">
                                        <div style={{ textAlign: "center", margin: "10px", minWidth: "80px" }}>
                                            <div className="icon-chucnang">
                                                <Link to={Links.ChamCong.QuanTriChamCongThang}>
                                                    <i className="icon-chucnang far fa-calendar-alt nav-icon"></i>
                                                </Link>
                                            </div>
                                            <p className="text-chucnang">
                                                <Link to={Links.ChamCong.QuanTriChamCongThang}>
                                                    <b className="text-chucnang">Chấm công tháng</b>
                                                </Link>
                                            </p>
                                        </div>
                                    </Col>
                                }
                                {menu[Links.ChamCong.QuanTriChamNgoaiGio] &&
                                    <Col span="6">
                                        <div style={{ textAlign: "center", margin: "10px", minWidth: "80px" }}>
                                            <div className="icon-chucnang">
                                                <Link to={Links.ChamCong.QuanTriChamNgoaiGio}>
                                                    <i className="icon-chucnang far fa-calendar-alt nav-icon"></i>
                                                </Link>
                                            </div>
                                            <p className="text-chucnang">
                                                <Link to={Links.ChamCong.QuanTriChamNgoaiGio}>
                                                    <b className="text-chucnang">Chấm công thêm giờ</b>
                                                </Link>
                                            </p>
                                        </div>
                                    </Col>
                                }
                                {menu[Links.ChamCong.DuyetChamCong] &&
                                    <Col span="6">
                                        <div style={{ textAlign: "center", margin: "10px", minWidth: "80px" }}>
                                            <div className="icon-chucnang">
                                                <Link to={Links.ChamCong.DuyetChamCong}>
                                                    <i className="icon-chucnang fas fa-check nav-icon"></i>
                                                </Link>
                                            </div>
                                            <p className="text-chucnang">
                                                <Link to={Links.ChamCong.DuyetChamCong}>
                                                    <b className="text-chucnang">Duyệt chấm công tháng</b>
                                                </Link>
                                            </p>
                                        </div>
                                    </Col>
                                }
                                {menu[Links.ChamCong.DuyetNgoaiGio] &&
                                    <Col span="6">
                                        <div style={{ textAlign: "center", margin: "10px", minWidth: "80px" }}>
                                            <div className="icon-chucnang">
                                                <Link to={Links.ChamCong.DuyetNgoaiGio}>
                                                    <i className="icon-chucnang fas fa-check nav-icon"></i>
                                                </Link>
                                            </div>
                                            <p className="text-chucnang">
                                                <Link to={Links.ChamCong.DuyetNgoaiGio}>
                                                    <b className="text-chucnang">Duyệt chấm thêm giờ</b>
                                                </Link>
                                            </p>
                                        </div>
                                    </Col>
                                }
                                {menu[Links.KPI.DuyetKPI] &&
                                    <Col span="6">
                                        <div style={{ textAlign: "center", margin: "10px", minWidth: "80px" }}>
                                            <div className="icon-chucnang">
                                                <Link to={Links.KPI.DuyetKPI}>
                                                    <i className="icon-chucnang fas fa-check nav-icon"></i>
                                                </Link>
                                            </div>
                                            <p className="text-chucnang">
                                                <Link to={Links.KPI.DuyetKPI}>
                                                    <b className="text-chucnang">Duyệt KPI</b>
                                                </Link>
                                            </p>
                                        </div>
                                    </Col>
                                }
                            </Row>
                        </div>
                    </Col>
                </Row>
                <ModalTextForm
                    show={confirmModal.isShowModal}
                    title={confirmModal.title}
                    handleClose={() => setConfirmModal({ isShowModal: false })}
                    handleSave={() => {
                        confirmModal.onSubmit();
                        setConfirmModal({ isShowModal: false });
                    }}
                >
                    {confirmModal.content}
                </ModalTextForm>
            </section>
        </div>
    );
};

export default Dashboard2;
